import { Box, Heading } from 'grommet'
import { GetServerSideProps } from 'next'
import { useTranslation } from 'next-i18next'

import { createPage } from 'util/ssp'
import Layout from 'components/layout/Layout'
import JoinGroupForm from 'components/group/form/JoinGroupForm'

export const getServerSideProps: GetServerSideProps = async function (ctx) {
  return await createPage(ctx, {})
}

export const JoinGroupPage = () => {
  const { t } = useTranslation()
  return (
    <Layout title={t('pages.group.join.title')}>
      <Box align="center" margin={{ bottom: 'xlarge' }}>
        <Heading>{t('pages.group.join.title')}</Heading>
        <Box margin={{ top: 'large' }}>
          <JoinGroupForm />
        </Box>
      </Box>
    </Layout>
  )
}

export default JoinGroupPage
